import { defineMessages } from 'react-intl'

const messages = defineMessages({
  mapSearchBoxPlaceholder: {
    id: 'map.searchBoxPlaceholder',
    description: 'The placeholder for the search box',
    defaultMessage: 'Search Map',
  },
  drawPolygon: {
    id: 'map.drawPolygon',
    description: 'Tooltip for draw polygon button',
    defaultMessage: 'Draw polygon',
  },
  clearPolygon: {
    id: 'map.clearPolygon',
    description: 'Tooltip for clear polygon button',
    defaultMessage: 'Clear polygon',
  },
})

export default messages
